/**
 * Curated starter templates for the send_webhook body.
 * Bodies are kept verbatim as specified — scalars string-quoted, {{matched_items}} unquoted.
 */

export interface WebhookTemplate {
  id: string;
  label: string;
  description: string;
  body: string;
  headers?: Record<string, string>;
}

export const WEBHOOK_TEMPLATES: WebhookTemplate[] = [
  {
    id: 'minimal',
    label: 'Minimal',
    description: 'Alarm name + severity. Works for any monitor type.',
    body: `{
  "alarm": "{{alarm_name}}",
  "severity": "{{severity}}",
  "time": "{{timestamp}}"
}`,
  },
  {
    id: 'generic',
    label: 'Generic JSON',
    description: 'All common fields as strings. Safe for every monitor type.',
    body: `{
  "alarm_id": "{{alarm_id}}",
  "alarm_name": "{{alarm_name}}",
  "watchpoint_id": "{{watchpoint_id}}",
  "type": "{{type}}",
  "severity": "{{severity}}",
  "status_code": "{{status_code}}",
  "latency_ms": "{{latency_ms}}",
  "is_up": "{{is_up}}",
  "error_message": "{{error_message}}",
  "timestamp": "{{timestamp}}"
}`,
  },
  {
    id: 'slack',
    label: 'Slack / Mattermost',
    description: 'Incoming-webhook text message.',
    headers: { 'Content-Type': 'application/json' },
    body: `{
  "text": "[{{severity}}] {{alarm_name}}\\nStatus: {{status_code}} | Latency: {{latency_ms}}ms\\nWatchpoint: {{watchpoint_id}}\\nTime: {{timestamp}}"
}`,
  },
  {
    id: 'discord',
    label: 'Discord',
    description: 'Discord webhook content.',
    body: `{
  "content": "[{{severity}}] {{alarm_name}} — status {{status_code}} at {{timestamp}}"
}`,
  },
  {
    id: 'teams_card',
    label: 'Microsoft Teams (MessageCard)',
    description: 'Legacy connector MessageCard.',
    body: `{
  "@type": "MessageCard",
  "@context": "http://schema.org/extensions",
  "summary": "{{alarm_name}}",
  "themeColor": "E81123",
  "title": "{{alarm_name}} ({{severity}})",
  "sections": [{
    "facts": [
      {"name": "Severity", "value": "{{severity}}"},
      {"name": "Status code", "value": "{{status_code}}"},
      {"name": "Latency", "value": "{{latency_ms}} ms"},
      {"name": "Time", "value": "{{timestamp}}"}
    ]
  }]
}`,
  },
  {
    id: 'pagerduty',
    label: 'PagerDuty (Events v2)',
    description: 'Trigger event. Replace routing_key.',
    body: `{
  "routing_key": "YOUR_ROUTING_KEY",
  "event_action": "trigger",
  "dedup_key": "{{alarm_id}}",
  "payload": {
    "summary": "{{alarm_name}} ({{severity}})",
    "source": "{{watchpoint_id}}",
    "severity": "{{severity}}",
    "timestamp": "{{timestamp}}"
  }
}`,
  },
  {
    id: 'security_waap',
    label: 'Security / WAAP (matched IPs)',
    description: 'Includes the violating entities. Data monitors (waap/delivery/elastic) only.',
    body: `{
  "alarm": "{{alarm_name}}",
  "severity": "{{severity}}",
  "count": "{{count}}",
  "matched_items": {{matched_items}}
}`,
  },
];
